import { NavigationEndpoint } from '@/Pages/SessionDetail/types';

/**
 * The clip editor is reachable at two endpoints — /clips for regular clips and /highlights for
 * highlight reels. They render the same page; the split exists so the nav rail can tell which
 * button is active from the URL alone.
 *
 * Anything that asks "am I in the clip editor?" has to accept both, hence this helper rather than
 * a pathname check spelled out at each call site.
 */
const CLIP_EDITOR_ENDPOINTS = [NavigationEndpoint.clips, NavigationEndpoint.highlights];

/**
 * True when `pathname` is a clip editor route (/clips or /highlights).
 */
export function isClipEditorPath(pathname: string | undefined | null): boolean {
  if (!pathname) {
    return false;
  }
  return CLIP_EDITOR_ENDPOINTS.some(endpoint => pathname.endsWith(`/${endpoint}`));
}

/**
 * The endpoint a clip should open at. Highlight reels live under /highlights so the Reels nav
 * button lights up; everything else — regular clips, full recordings — opens under /clips.
 */
export function clipEditorEndpoint(clipType?: string): NavigationEndpoint {
  return clipType === 'HIGHLIGHT_REEL' ? NavigationEndpoint.highlights : NavigationEndpoint.clips;
}
